import axios from "axios"
import { reportFileMime } from "@/utils/academyReportFiles"
const base = "/api/akademie/leadership/controlling"
const options = (extra = {}) => ({ ...extra, headers: { Authorization: localStorage.getItem("token") } })
const get = (path, params) => axios.get(`${base}${path}`, options({ params })).then(res => res.data)
const post = (path, data) => axios.post(`${base}${path}`, data, options()).then(res => res.data)
const put = (path, data) => axios.put(`${base}${path}`, data, options()).then(res => res.data)
const remove = (path, data) => axios.delete(`${base}${path}`, options({ data })).then(res => res.data)
export default {
  academyControl: {
    settings: () => get("/settings"),
    saveSettings: data => put("/settings", data),
    reports: (year, admin) => get("/reports", { year, admin: admin ? "1" : "0" }),
    report: id => get(`/reports/${id}`),
    prepareUpload: (id, file) => post(`/reports/${id}/uploads`, { fileName: file.name, mimeType: reportFileMime(file), size: file.size }),
    completeUpload: (id, media, revision) => post(`/reports/${id}/uploads/complete`, { media, revision }),
    cancelUpload: (id, media) => remove(`/reports/${id}/uploads`, { media }),
    review: (id, data) => put(`/reports/${id}/review`, data),
    comment: (id, text, revision) => post(`/reports/${id}/comments`, { text, revision }),
    filePath: (id, version) => `akademie/leadership/controlling/reports/${id}/file/${version}`,
    studioAudits: (studioId, page) => get("/audits/studio", { studioId, page }),
    audits: (studioId, page) => get("/audits", { studioId, page }),
    createAudit: data => post("/audits", data),
    updateAudit: (id, data) => put(`/audits/${id}`, data),
    deleteAudit: (id, revision) => remove(`/audits/${id}`, { revision }),
  },
}
